<template>
  <router-view />
</template>

<script>
export default {
  name: 'DayTripsGroupsIndex'
}
</script>
